<form class="schedule-settings-form" [formGroup]="formGroup" ngNativeValidate>
    <mat-grid-list cols="2" rowHeight="95px">
        <mat-grid-tile>
            <div class="container">
                <mat-slide-toggle class="turn-on-slider" [formControl]="turnOnSchedulerControl">
                    Turn On</mat-slide-toggle>
            </div>
        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field appearance="fill">
                <mat-label>Garbage Collector Interval</mat-label>
                <input matInput type="number" placeholder="e.g. 30"
                    [formControl]="garbageCollectorSchedulerIntervalMinControl" min="1">
                <span matSuffix class="value-suffix">
                    <mat-icon class="help-icon" [matTooltip]="'Interval between Garbage Collector runs.'">
                        info
                    </mat-icon>Min
                </span>
                <mat-error
                    *ngIf="garbageCollectorSchedulerIntervalMinControl.invalid && garbageCollectorSchedulerIntervalMinControl.errors.min">Min
                    interval: {{minGarbageCollectorSchedulerIntervalMin}} Min
                </mat-error>
                <mat-error
                    *ngIf="garbageCollectorSchedulerIntervalMinControl.invalid && garbageCollectorSchedulerIntervalMinControl.errors.max">Max
                    interval: {{maxGarbageCollectorSchedulerIntervalMin}} Min
                </mat-error>
                <mat-error
                    *ngIf="garbageCollectorSchedulerIntervalMinControl.invalid && garbageCollectorSchedulerIntervalMinControl.errors.pattern">Only
                    integer numbers allowed
                </mat-error>
            </mat-form-field>
        </mat-grid-tile>
    </mat-grid-list>
</form>